import { PictureAsPdf } from '@mui/icons-material';

import { FilePreviewBox } from './FilePreviewBox';

export interface PdfPreviewBoxProps {
  size?: number;
  iconSize?: number;
  onClick?: () => void;
}

export const PdfPreviewBox = (props: PdfPreviewBoxProps) => (
  <FilePreviewBox
    icon={PictureAsPdf}
    iconColor="error.main"
    label="PDF"
    {...props}
  />
);
